module.exports = __webpack_public_path__ + "img/1920_stores_img3.d0976a2a.png";